export default __webpack_public_path__ + "static/media/ic_bnb_40.c8946a89.svg";